import { Box, Toolbar } from '@mui/material';
import { Outlet } from 'react-router-dom';
import { AppHeader } from './AppHeader';
import { AppSidebar, SIDEBAR_WIDTH } from './AppSidebar';

/**
 * Top-level shell: header + sidebar + content area. The content column is a
 * flex column whose height is locked to the viewport so child pages can opt
 * into `flex: 1` and let big elements (e.g. a DataTable) fill the remaining
 * space instead of bottoming out at a fixed 540 px.
 */
export function AppLayout() {
  return (
    <Box sx={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <AppHeader />
      <AppSidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: `calc(100% - ${SIDEBAR_WIDTH}px)`,
          backgroundColor: 'background.default',
          height: '100vh',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {/* Spacer so the content starts below the fixed AppHeader. */}
        <Toolbar />
        <Box
          sx={{
            p: 3,
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'auto',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}
